import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { AttachImagesArticleComponent } from 'src/app/views/archive/article/attach-images-article/attach-images-article.component';
import { CustomModalComponent } from '../custom-modal/custom-modal.component';
import { CustomTableComponent } from '../custom-table/custom-table.component';
import { ArticleModel } from 'src/app/models/archive/article.model';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-custom-table-select',
  templateUrl: './custom-table-select.component.html',
  styleUrls: ['./custom-table-select.component.scss'],
  standalone: true,
  imports: [CustomTableComponent, CustomModalComponent]
})
export class CustomTableSelectComponent implements OnInit {

  @ViewChild('showImages') showImagesModalComponent?: CustomModalComponent | null = null;

  inputs$: BehaviorSubject<any>;
  filterPersistentKey: string = '';
  isFilterPersistent: boolean = false;
  output$: Subject<any>;
  subscription: Subscription;
  articleContract: ArticleModel = new ArticleModel();
  headers: ColumnResponseModel[] = [];
  data: PagedResponseModel<any> = new PagedResponseModel<any>();
  limitPaginator: boolean = false;
  showCheckbox: boolean = false;
  showRecover: boolean = false;
  actions: TableAction[] = [];
  isMultipleSelect: boolean = true;
  selectAllByDefault: boolean = false;
  filters: any[] = [];

  componentImage = AttachImagesArticleComponent;
  inputsForImagesSelect$ = new BehaviorSubject<any>({});

  constructor(public config: DynamicDialogConfig,
    private articleService: ArticleService,
    private cdr: ChangeDetectorRef,
    private toastHandlerService: ToastHandlerService
  ) { }

  ngOnInit() {
    const inputs$ = this.config.data?.inputs$;
    if (!inputs$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = inputs$?.subscribe((inputs: any) => {
      this.headers = inputs.headers ?? [];
      this.data = inputs.data ?? [];
      this.filterPersistentKey = inputs.filterPersistentKey ?? '';
      this.isFilterPersistent = inputs.isFilterPersistent ?? false;
      this.limitPaginator = inputs.limitPaginator ?? false;
      this.showCheckbox = inputs.showCheckbox;
      this.showRecover = inputs.showRecover;
      this.actions = inputs.actions ?? [];
      this.isMultipleSelect = inputs.isMultipleSelect;
      this.selectAllByDefault = inputs.selectAllByDefault;
      this.filters = inputs.filters ?? [];
    });
    const filters = localStorage.getItem(this.filterPersistentKey);
    this.onFilterChangeEmit({ filters: JSON.parse(filters ?? '[]') });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  onPageChangeEmit(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'onPageChange', payload: event });
  }

  onFilterChangeEmit(event: { filters: any }) {
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'onFilterChange', payload: event });
  }

  async onAction(event: { action: string, item?: any, selectedItems?: number[] }) {
    if (event.action === 'view-image') {
      if (event.item?.articleId != undefined) {
        const articleId = event.item?.articleId;
        await this.openShowImagesModal(articleId);
      } else {
        this.toastHandlerService.showToast('warning', 'Atención', 'No se encontró el identificador del articulo para ver sus imágenes.');
        console.error('No existe la columna articleId en el item');
      }
    }
  }

  async openShowImagesModal(articleId: number) {
    this.articleContract = await firstValueFrom(this.articleService.getArticleById(articleId))
    this.inputsForImagesSelect$.next({
      articleContract: this.articleContract,

      showButtons: false
    });
    this.cdr.detectChanges(); // Forzar actualización del binding [header] antes de abrir el modal
    this.showImagesModalComponent?.show();
  }

}
